export const createEmptyCustomerRecord = () => ({
  id: 0,
  distCode: "",
  code: "",
  name: "",
  status: "",
  contactPerson: "",
  contactNo: "",
  mobileNo: "",
  addr1: "",
  addr2: "",
  addr3: "",
  addr4: "",
  addr5: "",
  postalCode: "",
  customerHier3: "",
  invTermCode: "",
  creditLimit: "",
  taxRegNo: "",
  nodeDesc: "",
  branchCode: "",
  isActive: true,
});

// CSV column mapping for different file formats
export const CSV_CUSTOMER_COLUMN_MAPPINGS = {
  standard: {
    distCode: "DIST_CD",
    code: "CUST_CD",
    name: "CUST_NAME",
    status: "CUST_STATUS",
    contactPerson: "CONT_PR",
    contactNo: "CONT_NO",
    mobileNo: "MOBILE_NO",
    addr1: "ADDR_1",
    addr2: "ADDR_2",
    addr3: "ADDR_3",
    addr4: "ADDR_4",
    addr5: "ADDR_5",
    postalCode: "ADDR_POSTAL",
    customerHier3: "CUST_HIER3",
    invTermCode: "INTERM_CD",
    creditLimit: "CUST_CRDLIMIT",
    taxRegNo: "CUST_TAXREGNO",
    nodeDesc: "NODE_DESC",
    branchCode: "BRANCH_CD",
  },
};

// Validation rules for customer records
export const CUSTOMER_VALIDATION_RULES = {
  code: {
    required: true,
    minLength: 1,
    maxLength: 50,
  },
  name: {
    required: true,
    minLength: 1,
    maxLength: 255,
  },
  distCode: {
    required: true,
    maxLength: 100,
  },
  creditLimit: {
    required: false,
    type: "number",
    min: 0,
  },
};
